import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Grid, Button, Card, CardContent, Typography, Box, Divider } from '@mui/material';
import { FormProvider, RHFTextField } from '../../common/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';


const AddDeliveryLocation = (props) => {
    const { formLoading, currentId, handleData } = props;
    const phoneRegExp = /^\d{10}$/;
    const gstRegExp = /^[a-zA-Z0-9]{15}$/;
    const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const method = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                name: Yup.string().required("Name is required"),
                email: Yup.string()
                    .matches(emailRegExp, { message: 'Invalid email format', excludeEmptyString: true })
                    .required("Email is required"),
                contactNumber: Yup.string()
                    .matches(phoneRegExp, { message: 'Phone Number must be exactly 10 digits', excludeEmptyString: true })
                    .min(10, 'Phone Number must be at least 10 digits')
                    .required("Phone Number is required!"),
                gstin: Yup.string()
                    .matches(gstRegExp, { message: 'GST Number must be exactly 15 digits', excludeEmptyString: true })
                    .min(15, 'GST Number must be at least 15 digits')
                    .required("GST Number is required!"),
                pincode: Yup.string().matches(/^\d{6}$/, { message: 'Please enter a valid pincode' }).required('Please enter pincode'),
                state: Yup.string().required("State is required"),
                city: Yup.string().required("City is required"),
                address_line: Yup.string().required("Store Address is required"),
                receiver_name: Yup.string().required('Reciever Name is required'),
                dropOrganization: Yup.string().required('Drop Locaion is required'),
                country: Yup.string().required('Country is required'),
            })
        ),
        defaultValues: {
            name: '',
            email: '',
            contactNumber: '',
            gstin: '',
            address_line: '',
            pincode: '',
            state: '',
            city: '',
            receiver_name: '',
            dropOrganization: '',
            country: '',
            baralDestCode: '',
        },

    })

    const {
        handleSubmit,
        reset,
    } = method;

    const onSubmit = (data) => {
        handleData(data);
    };

    useEffect(() => {
        if (currentId && Object.keys(currentId).length > 0 && currentId.id) {
            let defaultValues = {
                name: currentId.name ? currentId.name : '',
                email: currentId.email ? currentId.email : '',
                contactNumber: currentId.contactNumber ? currentId.contactNumber : '',
                gstin: currentId.gstin ? currentId.gstin : '',
                address_line: currentId.address_line ? currentId.address_line : '',
                pincode: currentId.pincode ? currentId.pincode : '',
                state: currentId.state ? currentId.state : '',
                city: currentId.city ? currentId.city : '',
                receiver_name: currentId.receiver_name ? currentId.receiver_name : '',
                dropOrganization: currentId.dropOrganization ? currentId.dropOrganization : '',
                country: currentId.country ? currentId.country : '',
                baralDestCode: currentId.baralDestCode ? currentId.baralDestCode : '',
            };
            reset({ ...defaultValues });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentId]);
    return (
        <Card>
            <CardContent sx={{ p: 2.5 }}>
                <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={1.5}>
                        {/* Location Details Section */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600, fontSize: '0.95rem' }}>
                                Location Details
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Name *" name="name" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Email *" name="email" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Contact Number *" name="contactNumber" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="GSTIN *" name="gstin" />
                        </Grid>

                        {/* Address Details Section */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" sx={{ mt: 1, mb: 0.5, fontWeight: 600, fontSize: '0.95rem' }}>
                                Address Details
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Store Address *" name="address_line" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Pincode *" name="pincode" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="State *" name="state" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="City *" name="city" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Country *" name="country" />
                        </Grid>

                        {/* Delivery Details Section */}
                        <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="subtitle1" sx={{ mb: 0.5, fontWeight: 600, fontSize: '0.95rem' }}>
                                Delivery Details
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Receiver Name *" name="receiver_name" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField label="Drop Address *" name="dropOrganization" />
                        </Grid>

                        {/* Optional Fields Section */}
                        <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontStyle: 'italic', fontSize: '0.75rem' }}>
                                Optional Fields
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <RHFTextField
                                label="Baral Dest Code"
                                name="baralDestCode"
                                placeholder="Optional"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'action.hover',
                                    }
                                }}
                            />
                        </Grid>

                        {/* Action Buttons */}
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 1.5, mt: 1.5, justifyContent: 'flex-start' }}>
                                <LoadingButton
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    loading={formLoading}
                                    size="medium"
                                >
                                    Save
                                </LoadingButton>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="error"
                                    onClick={() => reset()}
                                    size="medium"
                                >
                                    Reset
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </FormProvider>
            </CardContent>
        </Card>
    );
};

export default AddDeliveryLocation;
